import {login, forgotPassword, accessAs, sendOtpCode, loginWithOtp} from "@/services/LoginService";
import { initializeAuthServiceReverb, resetAuthServiceReverb } from "../services/api/AuthService";
import { initializeMaterialsServiceReverb, resetMaterialsServiceReverb } from "../services/api/MaterialsApiService";
import { initializeQuizServiceReverb, verifyQuizServiceReverb } from "../services/api/QuizApiService";
import { initializeChatServiceReverb, verifyChatServiceReverbConnection } from "../services/api/ChatService";
import { initializeMaterialProductionReverb, verifyMaterialProductionServiceReverb } from "../services/api/MaterialProductionService";

const actions = {
  async resetReverbInstance({}) {
    resetAuthServiceReverb()
    resetMaterialsServiceReverb()
  },

  async initializeReverbInstances({ }, payload) {
    initializeMaterialsServiceReverb(payload.consumerToken)
    initializeAuthServiceReverb(payload.consumerToken)
    initializeChatServiceReverb(payload.consumerToken)

    if (payload.notRunningInProduction) {
      initializeQuizServiceReverb(payload.consumerToken)
      initializeMaterialProductionReverb(payload.consumerToken)
    }
  },

  async testReverbConnections({ }, consumerId) {
    verifyQuizServiceReverb(consumerId)
    verifyChatServiceReverbConnection(consumerId)
    verifyMaterialProductionServiceReverb(consumerId)
  },

  async doLogin({ commit, dispatch }, credentials) {
    try {
      await dispatch('resetUserDataUserModule')
      const response = await login(credentials);
      const userData = response?.data

      dispatch('setUserDataUserModule', userData)
      return userData?.type;

    } catch (error) {
      dispatch('toastfy/activeErrorNotification', { text: error?.response?.data?.message || "Erro ao realizar login! Tente novamente" })
    }
  },

  async forgotPassword({ commit, dispatch }, credentials) {
    try {
      const response = await forgotPassword(credentials);
      return response;
    } catch (error) {
      dispatch('toastfy/activeErrorNotification', { text: error?.response?.data?.message || "Ocorreu um erro ao redefinir senha! Tente novamente" })
      throw error;
    }
  },

  async accessAs({ commit, dispatch }, payload) {
    try {
      await dispatch('resetUserDataUserModule')

      const response = await accessAs(payload)

      const originalUserData = {
        ...response?.impersonator,
        company: response?.company,
        token: response?.impersonator_token,
      }

      const userData = {
        ...response?.user,
        company: response?.company,
        token: response?.target_token,
      }

      dispatch('setUserDataUserModule', userData)
      dispatch('setAccessAsUserData', originalUserData)

      return userData.type
    } catch (error) {
      if (error.response.status === 403) {
        dispatch('toastfy/activeErrorNotification', { text: "Você não tem permissão para acessar as informações deste usuário" })
        return
      }

      dispatch('toastfy/activeErrorNotification', { text: error?.response?.data?.message || "Ocorreu um erro ao acessar conta! Tente novamente" })
    }
  },

  async sendOtpCode({ dispatch }, payload) {
    try {
      await sendOtpCode(payload)
      dispatch('toastfy/activeSuccesNotification', { text: 'Código enviado! Verifique seu email' })
      return true
    } catch (error) {
      dispatch('toastfy/activeErrorNotification', { text: error?.response?.data?.message || 'Erro ao enviar código! Tente novamente' })
      return false
    }
  },

  async loginWithOtp({ commit, dispatch }, payload) {
    try {
      await dispatch('resetUserDataUserModule')
      const response = await loginWithOtp(payload)
      const userData = response?.data

      dispatch('setUserDataUserModule', userData)
      return userData?.type
    } catch (error) {
      dispatch('toastfy/activeErrorNotification', { text: error?.response?.data?.message || 'Código inválido! Tente novamente' })
    }
  }
};

export default {
  actions,
};
